import React, { useState } from 'react'

import { OtherPages } from './OtherPageStyled'
import { aboveTypes, handleAboveType } from '../../types'
import SFXS from '../../../assets/audios/audios'
interface OtherPagesCopm {
  name: aboveTypes
  clickable: boolean
  handleAbove: handleAboveType
  audio?: any
}
export const OtherPagesCopm = ({
  name,
  clickable,
  handleAbove,
  audio
}: OtherPagesCopm): JSX.Element => {
  const [anim, setanim] = useState(false)
  const { goForwardSFX } = SFXS
  goForwardSFX.volume = audio.volume

  return (
    <OtherPages
      clickable={clickable}
      onClick={() => {
        setanim(true)
        audio.sound && goForwardSFX.play()
        setTimeout(() => {
          setanim(false)
          handleAbove(name)
        }, 300)
      }}
      anim={anim}
    >
      <h3>{name}</h3>
    </OtherPages>
  )
}
